import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_3 = { class: "text-action" }
const _hoisted_4 = {
  key: 0,
  class: "position-absolute shadow-lg bg-danger-soft rounded text-center",
  style: {"top":"-50px","z-index":"10"}
}
const _hoisted_5 = { class: "popover-header text-danger p-3 mb-0 fw-bold" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-exclamation-circle" }, null, -1)

import { computed, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'FormButton',
  props: {
    disabled: { type: Boolean, default: false },
    marginVertical: { type: Boolean, default: true },
    loading: { type: Boolean, default: false },
    label: { default: "Field name" },
    form: { default: null },
    outline: { type: Boolean, default: false },
    color: { default: "secondary" },
    outlineColor: { default: "primary" }
  },
  emits: ["onClick"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const showError = ref(false);

const fieldError = computed(() => {
  if (!props.form) return;
  let msg = "";
  try {
    const messages = props.form.$silentErrors?.map((r: any) => r.$message);
    msg = messages.length ? messages[0] : "";
  } catch (e) {
    console.log(e);
    msg = "";
  } finally {
    return msg;
  }
});

const btnColor = computed(() =>
  props.outline ? `btn-outline-${props.outlineColor}` : `btn-${props.color}`,
);

const clicked = () => {
  if (props.disabled) return;
  emit("onClick");
};

const onMouseOver = () => {
  showError.value = true;
};

const onMouseLeave = () => {
  showError.value = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "position-relative justify-content-center d-flex",
    onMouseover: _cache[1] || (_cache[1] = ($event: any) => (onMouseOver())),
    onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (onMouseLeave()))
  }, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (clicked()), ["prevent"])),
      disabled: _ctx.loading,
      class: _normalizeClass(["btn w-100 rounded-5", [{ 'my-3': _ctx.marginVertical }, btnColor.value]])
    }, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2))
        : _createCommentVNode("", true),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.label), 1)
    ], 10, _hoisted_1),
    (showError.value && fieldError.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, [
            _hoisted_6,
            _createTextVNode(" " + _toDisplayString(fieldError.value), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 32))
}
}

})